type SVgProps = React.SVGProps<SVGSVGElement>;

export const SmallRightArrow = (props: SVgProps) => (
  <svg
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.707 5.29298L6.5605 3.14648L5.8535 3.85348L7.5 5.49998H2.5V6.49998H7.5L5.8535 8.14648L6.5605 8.85349L8.707 6.70698C8.89447 6.51946 8.99979 6.26515 8.99979 5.99998C8.99979 5.73482 8.89447 5.48051 8.707 5.29298Z"
      fill="currentColor"
    />
  </svg>
);
